import { VenueDetailsBySlugResponse } from "common/hooks";
import VenueMapperNotes from "./VenueNotes/VenueMapperNotes";

type AlertsTabProps = {
  venueDetailsResponse: VenueDetailsBySlugResponse;
  onRefresh: () => void;
  showMapperView: boolean;
  onEdit: (note: any) => void;
  onFlagNote: (note: any) => void;
  onNotificationClick: () => void;
  isNotificationEnabled: () => boolean;
};

function AlertsTab({
  venueDetailsResponse,
  onRefresh,
  showMapperView,
  onEdit,
  onFlagNote,
  onNotificationClick,
  isNotificationEnabled,
}: AlertsTabProps) {
  return (
    <VenueMapperNotes
      venueDetailsResponse={venueDetailsResponse}
      onRefresh={onRefresh}
      showMapperView={showMapperView}
      onEdit={onEdit}
      onFlagNote={onFlagNote}
      onNotificationClick={onNotificationClick}
      isNotificationEnabled={isNotificationEnabled}
    />
  );
}

export default AlertsTab;
